export default __webpack_public_path__ + "static/media/DanskeNarrow.99670906.ttf";